import { useToasts } from "react-toast-notifications";
import { twMerge } from "tailwind-merge";

import { IconButton } from "@components/v2/buttons/icon-button";
import { Body } from "@components/v2/typography/body";

type CopyTextButtonProps = {
  textToCopy: string;
  successMessage?: string;
  children?: React.ReactNode;
  className?: string;
};
export const CopyTextButton = ({
  textToCopy,
  successMessage = "Copied to clipboard!",
  children,
  className,
}: CopyTextButtonProps) => {
  const { addToast } = useToasts();
  const copyToClipboard = () => {
    window.navigator.clipboard.writeText(textToCopy);
    addToast(successMessage, { appearance: "success" });
  };
  return (
    <div
      className={twMerge(
        "flex gap-1 items-center cursor-pointer hover:text-v2-action-hover",
        className,
      )}
      onClick={copyToClipboard}
    >
      {children ?? (
        <Body variant={300} fontWeight="regular" className="text-inherit">
          {textToCopy}
        </Body>
      )}
      <IconButton
        variant="secondary"
        size="sm"
        className="p-1 w-min border-0 focus:outline-none focus:ring-0 focus:bg-transparent active:shadow-none h-min"
      >
        <i className="fa-regular fa-sharp fa-copy" />
      </IconButton>
    </div>
  );
};
